<template>
  <div class="comment_list">
    <p class="comemnt-total">
      {{ `共 ${listData.length} 条评论` }}
    </p>
    <van-list
      v-model="loading"
      :finished="finished"
      offset="100"
      :immediate-check="false"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div v-for="(item, index) in listData" :key="item.id" class="list-wrap">
        <comment-list-item
          :item="item"
          :noBorder="index === listData.length - 1"
        >
          <div v-for="(value, i) in item.nextComments">
            <comment-list-item
              isNext
              :item="value"
              :noBorder="i === item.nextComments.length - 1"
            />
          </div>
        </comment-list-item>
      </div>
      <van-divider
        v-if="listData.length > 0"
        slot="finished"
        :style="{ fontSize: '12px', padding: '0 30px' }"
      >
        我也是有底线的~
      </van-divider>
      <van-empty v-else
      >
      <img slot="image" src="@/assets/images/empty.png" class="empty-img" alt=""><span slot="description" class="tips">这里什么都没有,连一片树叶也没飘过...</span></van-empty
    >
  </van-list>
    </van-list>
  </div>
</template>

<script>
import {
  getFoodFirstCommentList,
  getSceneryFirstCommentList,
  getGoodFirstCommentList,
  getPaperFirstCommentList
} from '@/service/api'
import CommentListItem from '@/components/CommentListItem.vue'
export default {
  components: {
    CommentListItem,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    addParams: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 5,
      loading: false,
      finished: false,
      isLoading: false, // 防止重复加载
      error: false,
      listData: [],
    }
  },
  mounted() {
    this._getListData()
  },
  methods: {
    async _getListData() {
      if (this.finished) return
      if (this.isLoading) return
      this.isLoading = true
      this.loading = true
      const pageParams = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      }
      const data = Object.assign({}, pageParams, this.addParams)
      try {
        let res = null
        if (this.type === 'food') {
          res = await getFoodFirstCommentList(data)
        } else if (this.type === 'scenery') {
          res = await getSceneryFirstCommentList(data)
        }else if (this.type==='good'){
          res = await getGoodFirstCommentList(data)
        }else if (this.type==='paper'){
          res = await getPaperFirstCommentList(data)
        }
        if (res) {
          this.listData = [...this.listData, ...res.list]
          if (!res.hasNextPage) {
            this.finished = true
            this.isLoading = true
            return
          }
          this.currentPage++
          this.loading = false
          this.isLoading = false
        } else {
          this.error = true
        }
      } catch (error) {
        this.isLoading = false
        this.$toast(`${error}`)
      }
    },
    // 加载更多
    onLoad() {
      console.log('加载更多')
      this._getListData()
    },
  },
}
</script>

<style lang="less" scoped>
.comment_list {
  padding: 10px 15px;
  border-top: 10px solid #f8f8f8;
  .comemnt-total {
    font-size: 16px;
    margin: 10px 0;
    color: #9e9e9e;
  }
  .empty-img{
    width: 200px;
    height: 120px;
    margin-left: -20px;
   margin-top: 30px;
  }
  .tips{
    font-size: 10px;
  }
}
</style>
